export function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#12352B] text-[#A3B18A] py-12 px-6 font-sans text-xs border-t border-white/10"
    >
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4 pb-16">
        <div>
          <p className="font-bold text-white font-editorial text-sm">Alberto Rameni</p>
          <p className="mt-1">Consulente Senior SumUp · Operatività su tutto il territorio nazionale</p>
        </div>
        <div className="text-center md:text-right">
          <p className="text-[#736F67]">Analisi commissioni e consulenza senza impegno.</p>
          <a href="/admin" data-testid="footer-admin-link" className="inline-block mt-2 text-[#A3B18A] underline underline-offset-4 hover:text-white transition-colors">
            Area Riservata
          </a>
        </div>
      </div>
    </footer>
  );
}
